import styled from 'styled-components'

// ========================== Styled components ================================

export const NoVideosYet = styled.div`
  min-height: 250px;
  margin-top: 100px;
  margin-bottom: 200px;
  font-size: 30px;
  font-weight: 600;
  text-align: center;

  // mobile
  @media (max-width: 43em) {
    margin-top: 80px;
    font-size: 24px;
  }
`
